<div class="predictive-container">

    <div class="chart-section">
        <div class="chart-header">
            <h3>Kurtosis Trend</h3>
            <div class="filter-actions">
                <button *ngIf="selectedTimeFilter === 'hourly'" type="button" mat-raised-button
                    color="primary">Hourly</button>
                <button *ngIf="selectedTimeFilter !== 'hourly'" type="button" mat-stroked-button color="primary"
                    (click)="changeTimeFilter('hourly')">Hourly</button>

                <button *ngIf="selectedTimeFilter === 'daily'" type="button" mat-raised-button
                    color="primary">Daily</button>
                <button *ngIf="selectedTimeFilter !== 'daily'" type="button" mat-stroked-button color="primary"
                    (click)="changeTimeFilter('daily')">Daily</button>

                <button *ngIf="selectedTimeFilter === 'weekly'" type="button" mat-raised-button
                    color="primary">Weekly</button>
                <button *ngIf="selectedTimeFilter !== 'weekly'" type="button" mat-stroked-button color="primary"
                    (click)="changeTimeFilter('weekly')">Weekly</button>
            </div>
        </div>

        <div class="loading-container" *ngIf="charts.autoRegression.loading">
            <div class="spinner"></div>
            <p>Loading regression data...</p>
        </div>

        <div class="no-data"
            *ngIf="!charts.autoRegression.loading && (!charts.autoRegression.dataSeries || charts.autoRegression.dataSeries.length === 0)">
            <p>No data available</p>
        </div>

        <app-trends-chart *ngIf="!charts.autoRegression.loading && charts.autoRegression.dataSeries.length > 0"
            [dataSeries]="charts.autoRegression.dataSeries" [thresholds]="charts.autoRegression.thresholds"
            titleY="Velocity (mm/sec)"></app-trends-chart>
    </div>

    <div class="chart-section">
        <div class="chart-header">
            <h3>Envelop Analysis</h3>

            <div class="diagnostic-badge" *ngIf="charts.envelope.diagnosticMessage">
                <span class="badge-label">Diagnostic:</span>
                <span class="badge-text">{{ charts.envelope.diagnosticMessage }}</span>
            </div>
        </div>

        <div class="loading-container" *ngIf="charts.envelope.loading">
            <div class="spinner"></div>
            <p>Loading envelope data...</p>
        </div>

        <div class="no-data"
            *ngIf="!charts.envelope.loading && (!charts.envelope.dataSeries || charts.envelope.dataSeries.length === 0)">
            <p>No data available</p>
        </div>

        <app-trends-chart *ngIf="!charts.envelope.loading && charts.envelope.dataSeries.length > 0"
            [dataSeries]="charts.envelope.dataSeries" titleY="Envelope Analysis"
            titleX="Frequency (Hz)"></app-trends-chart>
    </div>

</div>
